/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineTaxDto } from './traveline-tax-dto';
import {
    TravelineTaxDtoFromJSON,
    TravelineTaxDtoFromJSONTyped,
    TravelineTaxDtoToJSON,
    TravelineTaxDtoToJSONTyped,
} from './traveline-tax-dto';

/**
 * 
 * @export
 * @interface TravelineTotalDto
 */
export interface TravelineTotalDto {
    /**
     * Price excluding taxes and fees to be paid at check-in
     * @type {number}
     * @memberof TravelineTotalDto
     */
    priceBeforeTax: number;
    /**
     * Amount of taxes and fees to be paid at check-in
     * @type {number}
     * @memberof TravelineTotalDto
     */
    taxAmount: number;
    /**
     * Taxes and fees to be paid at check-in
     * @type {Array<TravelineTaxDto>}
     * @memberof TravelineTotalDto
     */
    taxes?: Array<TravelineTaxDto> | null;
}

/**
 * Check if a given object implements the TravelineTotalDto interface.
 */
export function instanceOfTravelineTotalDto(value: object): value is TravelineTotalDto {
    if (!('priceBeforeTax' in value) || value['priceBeforeTax'] === undefined) return false;
    if (!('taxAmount' in value) || value['taxAmount'] === undefined) return false;
    return true;
}

export function TravelineTotalDtoFromJSON(json: any): TravelineTotalDto {
    return TravelineTotalDtoFromJSONTyped(json, false);
}

export function TravelineTotalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineTotalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'priceBeforeTax': json['priceBeforeTax'],
        'taxAmount': json['taxAmount'],
        'taxes': json['taxes'] == null ? undefined : ((json['taxes'] as Array<any>).map(TravelineTaxDtoFromJSON)),
    };
}

  export function TravelineTotalDtoToJSON(json: any): TravelineTotalDto {
      return TravelineTotalDtoToJSONTyped(json, false);
  }

  export function TravelineTotalDtoToJSONTyped(value?: TravelineTotalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceBeforeTax': value['priceBeforeTax'],
        'taxAmount': value['taxAmount'],
        'taxes': value['taxes'] == null ? undefined : ((value['taxes'] as Array<any>).map(TravelineTaxDtoToJSON)),
    };
}

